import React, { Component } from 'react';
import {connect} from 'react-redux';
import { addSubOptionBySubQuestion, emptyDemographicsOption, updateOptionByQuestion, } from '../../actions/demographics';
import AddSubOption from '../../components/demographics/addSubOption';

class AddDemoSubOption extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
      this.quesId = this.queryString.split("/&q:")[1].split('/')[0];  
      this.subQuesId = this.queryString.split("/&sq:")[1];
    }

    this.state={
      quesId : this.quesId,
      subQuesId : this.subQuesId
    };

    this.addSubOptionBySubQuestion = this.addSubOptionBySubQuestion.bind(this);
    this.emptyDemographicsOption = this.emptyDemographicsOption.bind(this);
  }

  componentDidMount(){
    
  }

  addSubOptionBySubQuestion(data){
    this.props.dispatch(addSubOptionBySubQuestion(data));
  }

  emptyDemographicsOption( ){
    this.props.dispatch(emptyDemographicsOption());
  }
  

  render(){

    let showAddOptionView = "";
    if(this.state.quesId){
         showAddOptionView = <AddSubOption
         quesId = {this.state.quesId}
         subQuesId = {this.state.subQuesId}
         addSubOptionBySubQuestion = {this.addSubOptionBySubQuestion}

         demoGraphicsSubOptionAddSuccess = {this.props.demoGraphicsSubOptionAddSuccess}
         demoGraphicsSubOptionSuccessmessage = {this.props.demoGraphicsSubOptionSuccessmessage}
         demoGraphicsSubOptionFailmessage = {this.props.demoGraphicsSubOptionFailmessage}

         emptyDemographicsOption = {this.emptyDemographicsOption}
      />
    }
      
    return (
        <div> 
             {showAddOptionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSubOptionAddSuccess : state.demographics.demoGraphicsSubOptionAddSuccess,
    demoGraphicsSubOptionSuccessmessage : state.demographics.demoGraphicsSubOptionSuccessmessage,
    demoGraphicsSubOptionFailmessage : state.demographics.demoGraphicsSubOptionFailmessage,    
  }
}

export default connect(mapStateToProps)(AddDemoSubOption);



// WEBPACK FOOTER //
// ./src/pages/demographics/addSubOption.js